module.exports = __webpack_public_path__ + "static/img/about2.e68eb7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about2.png
// module id = Zr40
// module chunks = 0